module.exports = __webpack_public_path__ + "static/media/star_gris.0e872656.svg";